// extracted by mini-css-extract-plugin
export default {"ModalBody":"BroadcastList_ModalBody__jkJZm"};